import * as types from "./actionTypes";

export const modalData = data => {
  return {
    type: types.PETTY_CASHIER_SELECTION_MODAL_DATA,
    data
  };
};
export const closeModal = () => {
  return {
    type: types.PETTY_CASHIER_SELECTION_CLOSE_MODAL
  };
};
